import { meses } from "./meses";

/**
 * FUNCIÓN QUE RETORNA FORMATEA LA FECHA
 * @returns STRING DE FECHA EN FORMATO DD-MM-YYYY
 */
const formatearFecha = fecha => {
    const [yyyy, mm, dd] = fecha.split("-");
    if(yyyy && mm&& dd) return `${dd}-${meses[Number(mm)]}-${yyyy}`;
    else return "-"
}

export default formatearFecha;